import { default as mBankPalette } from './themed/mBankPalette';
const BASE_BLACK_COLOR = '#000000';
const BASE_WHITE_COLOR = '#ffffff';
export const palette = {
  inherit: 'inherit',
  transparent: 'transparent',
  solidBlack: BASE_BLACK_COLOR,
  solidWhite: BASE_WHITE_COLOR,
  ...mBankPalette
};
export const reversedPalette = Object.fromEntries(Object.entries(palette).map(entry => [entry[1], entry[0]]));
export default palette;